<template>
  <div class="post-item" ref="post">
    <div
      class="top-container"
      v-show="type === 'normal'"
      @click="userInfoClick"
    >
      <div
        class="user-image"
        v-lazy:background-image="model.user.social_profile_picture"
      ></div>
      <div class="username-container">
        <div class="username">{{ model.user.social_username }}</div>
        <div v-show="model.user.social_is_verified" class="approve-icon"></div>
      </div>
    </div>
    <image-shade style="cursor: default" :src="model.coverUrl">
      <div
        class="post-image-container"
        :style="{ 'background-image': `url(${model.coverUrl})` }"
      >
        <div class="video-icon" v-show="model.hasVideo"></div>
        <div class="mul-icon" v-if="model.images.length > 1"></div>
        <div class="mask" @click="showRepostDetail">
          <div class="text-container">{{ model.caption }}</div>
          <div class="hour-container">{{ model.postStr }}</div>
        </div>
      </div>
    </image-shade>
    <div class="post-info-list">
      <div class="info-item">
        <div class="icon like"></div>
        <div class="num-text">{{ model.likeNum | numAbbreviation }}</div>
      </div>
      <div class="info-item" v-if="model.hasVideo">
        <div class="icon view"></div>
        <div class="num-text">{{ model.viewNum | numAbbreviation }}</div>
      </div>
      <div class="info-item">
        <div class="icon common"></div>
        <div class="num-text">{{ model.commentNum | numAbbreviation }}</div>
      </div>
    </div>
    <div class="bottom-container">
      <div
        class="saved-icon"
        :class="{ select: model.saved }"
        @click="saveClick"
      ></div>
      <div class="repost-btn" @click="repost">Repost</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme.less";

.post-item {
  width: 190px;
  display: inline-block;
  background: white;
  border: 1px solid #e6e6e6;
  margin: 8px;

  .top-container {
    height: 44px;
    display: flex;
    padding: 0 10px;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    .user-image {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-size: contain;
    }

    .username-container {
      display: flex;
      align-items: center;

      .username {
        margin-left: 10px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
        max-width: 110px;
      }

      .approve-icon {
        background-image: url("../../../public/images/schedule_posts/tag_people/approve@3x.png");
        width: 13px;
        height: 13px;
        background-size: contain;
        margin-left: 4px;
        position: relative;
      }
    }
  }

  .post-image-container {
    width: 188px;
    height: 188px;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    .mul-icon {
      background-image: url("../../../public/images/library/album@3x.png");
      width: 25px;
      height: 25px;
      background-size: contain;
      background-position: center;
      position: absolute;
      right: 5px;
      top: 5px;
    }

    .video-icon {
      width: 55px;
      height: 55px;
      z-index: 2;
      background-size: cover;
      background-image: url("../../../public/images/schedule_posts/list/video.png");
      position: absolute;
    }

    &:hover {
      .mask {
        display: block;
        z-index: 5;
        cursor: pointer;
      }
    }

    .mask {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.3);
      display: none;
      font-size: 12px;
      color: white;

      .text-container {
        margin: 10px;
        white-space: pre-wrap;
        word-break: break-all;
        height: 136px;
        overflow: auto;
      }

      .hour-container {
        padding: 10px;
        text-align: right;
        font-size: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }

  .post-info-list {
    margin: 0 10px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    height: 34px;
    font-size: 9px;
    justify-content: space-between;
    cursor: default;
    text-transform: lowercase;

    .info-item {
      display: flex;
      align-items: center;

      &:first-child {
        margin-left: 0;
      }

      .icon {
        background-size: contain;
        width: 12px;
        height: 12px;
        margin-right: 3px;

        &.like {
          background-image: url("../../../public/images/schedule_posts/list/icon_like@3x.png");
        }

        &.common {
          background-image: url("../../../public/images/schedule_posts/list/icon_com@3x.png");
        }

        &.view {
          background-image: url("../../../public/images/schedule_posts/list/icon_view@3x.png");
        }
      }

      .num-text {
        font-size: 12px;
      }
    }
  }

  .bottom-container {
    flex: 1;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    font-size: 16px;
    color: @theme-color;

    .saved-icon {
      width: 24px;
      height: 24px;
      background-size: contain;
      cursor: pointer;
      background-image: url("../../../public/images/repost/Saved@3x.png");

      &.select {
        background-image: url("../../../public/images/repost/Saved_Filled@3x.png");
      }
    }

    .repost-btn {
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
  }
}
</style>

<script>
import { numAbbreviation } from "../../filters/schedule";
import { CURRENT_PUBLISHER_SIMPLE } from "../../store/mutation-types";
import { mapGetters } from "vuex";
import ImageShade from "../common/media/ImageShade";
import { mediaSave, delMediaSaved } from "../../service/instagram";
import { showErrorMsg } from "../../utils/errors";

export default {
  name: "RepostPostItemComponent",
  components: { ImageShade },
  filters: { numAbbreviation },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    type: {
      // normal 普通形式 profile 用户中的Post隐藏用户信息的头部
      type: String,
      default: "normal",
    },
  },
  methods: {
    /**
     * 跳转用户详情点击事件
     */
    userInfoClick() {
      this.$bus.$emit("toInsProfile", this.model);
    },
    async showRepostDetail() {
      try {
        this.$bus.$emit("showRepostDetail", this.model);
      } catch (e) {
        showErrorMsg(e);
      }
    },
    async repost() {
      try {
        this.model.canSwitch = true;
        const scheduleForm = {
          images: this.model.images,
          user: this.model.user,
          type: "saved",
          form: this.model.form,
          mediaType: this.model.mediaType,
        };
        this.$bus.$emit("showScheduleForm", scheduleForm);
      } catch (e) {
        showErrorMsg(e);
      }
    },
    /**
     * 未保存点击为保存，否则为取消
     */
    async saveClick() {
      const loading = this.$loading({
        target: this.$refs.post,
      });
      try {
        if (this.model.saved) {
          await delMediaSaved({
            mediaId: this.model.mediaId,
            model: this.model,
          });
        } else {
          await mediaSave({ mediaId: this.model.mediaId, model: this.model });
        }
        this.model.saved = !this.model.saved;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
};
</script>
